var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "section-wrapper w-100" }, [
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body fees-costs-wrapper pt-0 px-2" },
          [_c("fees-costs", { on: { save: _vm.handleSaveFees } })],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("h2", { staticClass: "section-separator-title" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("direct-to-lender.fees.calculatedDetails")) +
                    "\n            "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card-body" },
          [
            _c("calculated-details", {
              attrs: {
                "application-id": _vm.applicationId,
                "client-username": _vm.clientUsername,
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }